import React, { memo } from 'react';
import { ShortGameDescription } from '../../../components/ShortGameDescription/ShortGameDescription';
import { clsx } from 'js/utils/classNames.util';
import { ITranslateMethod } from 'js/hooks/i18n/types';
import { preventSwipeOnScroll } from '../../../utils';

import style from './FullDescription.scss';

type FullDescriptionProps = {
    t: ITranslateMethod;
    shortDescription?: string;
    fullDescription?: string;
    descriptionGameProvider?: string;
    code: string;
    className?: string;
}

const FullDescription = ({
    fullDescription,
    descriptionGameProvider,
    shortDescription,
    t,
    className = ''
}: FullDescriptionProps) => {
    return (
        <div className={clsx([
            style.fullDescriptionContainer,
            className
        ])}>
            <div className={style.fullDescription} onTouchStart={preventSwipeOnScroll}>
                <ShortGameDescription
                    description={fullDescription}
                    className={style.shortDescriptionLeft}
                />
                {descriptionGameProvider && (
                    <ShortGameDescription
                        title={t('playtech.mobile.system.responsivegames.game.infoPopup.gameProvider')}
                        description={descriptionGameProvider}
                        className={style.shortDescriptionLeft}
                    />
                )}
                {shortDescription && (
                    <ShortGameDescription
                        title={t('playtech.mobile.system.responsivegames.game.infoPopup.einsatz')}
                        isDangerouslySetInnerHTML
                        description={shortDescription}
                        className={style.shortDescriptionLeft}
                    />
                )}
                {/* <FeatureCategories code={code}/> was deleted */}
            </div>
        </div>
    );
};

export default memo(FullDescription);
